document.addEventListener('DOMContentLoaded', function () {
    const accordionHeaders = document.querySelectorAll('.accordeon__header');

    if (!accordionHeaders.length) return;

    accordionHeaders.forEach(header => {
        header.addEventListener('click', function () {
            const item = this.parentNode;
            const isActive = item.classList.contains('is-active');

            // Close all other open items
            document.querySelectorAll('.accordeon__item.is-active').forEach(activeItem => {
                if (activeItem !== item) {
                    collapseItem(activeItem);
                }
            });

            if (isActive) {
                collapseItem(item);
            } else {
                expandItem(item);
            }
        });
    });

    function expandItem(item) {
        const content = item.querySelector('.accordeon__content');
        if (!content) return;

        item.classList.add('is-active');
        content.style.maxHeight = content.scrollHeight + 'px';

        // Remove fixed max-height after transition so content can resize dynamically
        const onEnd = () => {
            if (item.classList.contains('is-active')) {
                content.style.maxHeight = 'none';
            }
            content.removeEventListener('transitionend', onEnd);
        };
        content.addEventListener('transitionend', onEnd);
    }

    function collapseItem(item) {
        const content = item.querySelector('.accordeon__content');
        if (!content) return;

        // Snapshot current height before collapsing
        if (content.style.maxHeight === 'none' || !content.style.maxHeight) {
            content.style.maxHeight = content.scrollHeight + 'px';
        }

        // Force reflow, then animate to 0
        content.offsetHeight;
        requestAnimationFrame(() => {
            content.style.maxHeight = '0px';
            item.classList.remove('is-active');
        });
    }
});
